import { Navigate, RouteObject } from "react-router-dom";

export const globalSearchRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Global Search" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { Component: Page };
    },
    children: [
      { index: true, element: <Navigate replace to="merchant-app" /> },
      {
        path: "merchant-app",
        handle: { breadcrumb: "Merchant App" },
        async lazy() {
          const { MerchantAppGlobalSearchPage } = await import(
            "./pages/merchant-app-redo-documentation-page"
          );
          return { Component: MerchantAppGlobalSearchPage };
        },
        children: [
          {
            path: "create",
            handle: { breadcrumb: "Create Redo Documentation Reference" },
            async lazy() {
              const { CreateMerchantRedoDocumentationPage } = await import(
                "./pages/create-merchant-redo-documentation-page"
              );
              return { Component: CreateMerchantRedoDocumentationPage };
            },
          },
          {
            path: "update-merchant-redo-documentation/:id",
            handle: { breadcrumb: "Update Redo Documentation Reference" },
            async lazy() {
              const { UpdateMerchantRedoDocumentationPage } = await import(
                "./pages/update-merchant-redo-documentation-page"
              );
              return { Component: UpdateMerchantRedoDocumentationPage };
            },
          },
        ],
      },
    ],
  },
];
